import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { UpgradePage } from 'pages/settings/pages/billing/pages/upgrade/ui/upgradePage'

export const UpgradeRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route path={'/'} element={<UpgradePage />} />
    </RoutesWithNotFound>
  )
})
